/**
 * @description: 采购明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="sr-cgm-report">
        <div class="cm-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="cm_time">
                        <input type="text" class="form-control laydate-icon" v-model="cm_start_time"> -
                        <input type="text" class="form-control laydate-icon" v-model="cm_end_time">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="cm_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="cm_stock" data-placeholder="请选择仓库">
                    </select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="cm_goods_type" data-placeholder="请选择商品类型"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">供应商:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="cm_supplier" data-placeholder="请选择供应商"></select>
                </div>
                <label class="list-label-4">采购类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="cm_type">
                        <option value="0">全部</option>
                        <option value="1">采购</option>
                        <option value="2">赠送</option>
                        <option value="3">盈余</option>
                        <option value="4">换货</option>
                        <option value="-1">退货</option>
                        <option value="5">客遗</option>
                    </select>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="cm_goods_name">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="initCmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getCmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">采购数量:</label>
                <div class="list-total" ref="cm_total"></div>
                <label class="list-label-5">进货价合计:</label>
                <div class="list-total" ref="cm_amount"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="cm_list"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="cmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='cmExport_allcheck' @click='cmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="create_time">
                            <label>进货时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="number">
                            <label>进货单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="type_name">
                            <label>类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="store_name">
                            <label>仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="quantity">
                            <label>数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="supplier_name">
                            <label>供应商</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="amount">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="contract_amount">
                            <label>合同价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cmExport_checkModel' value="amount_total">
                            <label>进货价合计</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='cmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='cmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                cm_start_time: "",
                cm_end_time: "",
                cm_goods_name: "",
                cmExport_allcheck: false,
                c_cmExport_allcheck: false,
                cmExport_checkModel: [],
                cmExport_checkData: ['create_time', 'number', 'type_name', 'store_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'supplier_name', 'amount', 'contract_amount', 'amount_total'],
                cmExport_type: 1,
            }
        },
        watch: {
            cmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.cmExport_checkModel.length >= this.cmExport_checkData.length) {
                        this.cmExport_allcheck = true;
                        this.c_cmExport_allcheck = true;
                    } else {
                        this.cmExport_allcheck = false;
                        this.c_cmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.cm_start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.cm_end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.getGoodsType(); // 商品类型
            this.getSupplier(); // 供应商
            this.innitInput();  // 门店
            $(this.$refs.cm_type).select2({
                minimumResultsForSearch: -1,
                width: '100%'
            });
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.cm_time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    }
                }, function(start, end, label) {
                    _this.cm_start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.cm_end_time = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.cm_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.cm_stock).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.cm_stock).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.cm_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.cm_stock).prop("disabled", false);
                            $(_this.$refs.cm_stock).val('').trigger('change');
                            _this.getstockdata(data.response.result[1].id);
                            _this.initCmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let boxdatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.cm_stock).html("");
                $(this.$refs.cm_stock).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 获取商品类型
            getGoodsType: function() {
                const _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.cm_goods_type).html("");
                            $(_this.$refs.cm_goods_type).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取供应商
            getSupplier: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getSupplier",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{id: '0', text: '全部'}];
                            $.each(data.response.result.data.rows, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.cm_supplier).html("");
                            $(_this.$refs.cm_supplier).select2({
                                data: arr,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 表格
            initCmTable: function() {
                let _this = this;
                $(_this.$refs.cm_list).bootstrapTable('destroy');
                $(_this.$refs.cm_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getCmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "create_time",
                        title: "进货时间",
                        width: "100",
                        valign: "middle"
                    }, {
                        field: "number",
                        title: "进货单号",
                        width: "110",
                        valign: "middle"
                    }, {
                        field: "type_name",
                        title: "类型",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "store_name",
                        title: "仓库",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "supplier_name",
                        title: "供应商",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "amount",
                        title: "进货单价",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "contract_amount",
                        title: "合同价",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "amount_total",
                        title: "进货价合计",
                        width: "9%",
                        valign: "middle"
                    }],
                });
            },
            getCmList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.cm_shop).val(),
                    store_id = $.trim($(_this.$refs.cm_stock).val()),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.cm_start_time,
                            "end_time": _this.cm_end_time,
                            "shop_id": shop_id,
                            "store_id": store_id,
                            "goods_type": $.trim($(_this.$refs.cm_goods_type).val()),
                            "supplier_id": $(_this.$refs.cm_supplier).val(),
                            "type": $(_this.$refs.cm_type).val(),
                            "goods_name": _this.cm_goods_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPurchaseDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.cm_total).text(data.response.result.quantity_total);
                            $(_this.$refs.cm_amount).text(data.response.result.amount_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getCmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/purchaseDetailExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.cmExport_checkModel = data.response.result.export_fields;
                                _this.cmExport_type = data.response.result.export_type;
                            } else {
                                _this.cmExport_checkModel = _this.cmExport_checkData;
                                _this.cmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.cmExport_alert)
                }, function() {
                    _this.exportCmList();
                });
            },
            // 导出字段全选
            cmExportCheckedAll: function() {
                let _this = this;
                _this.cmExport_allcheck = _this.c_cmExport_allcheck;
                if(!_this.cmExport_allcheck) { // 实现全选
                    _this.cmExport_checkModel = [];
                    _this.cmExport_checkData.forEach(function(item) {
                        _this.cmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.cmExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportCmList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.cmExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/purchaseDetailExport" +
                    "?start_time=" + _this.cm_start_time +
                    "&end_time=" + _this.cm_end_time +
                    "&shop_id=" + $(_this.$refs.cm_shop).val() +
                    "&store_id=" + $.trim($(_this.$refs.cm_stock).val()) +
                    "&goods_type=" + $.trim($(_this.$refs.cm_goods_type).val()) +
                    "&supplier_id=" + $(_this.$refs.cm_supplier).val() +
                    "&type=" + $(_this.$refs.cm_type).val() +
                    "&goods_name=" + _this.cm_goods_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.cmExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .cm-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1500px;
                // table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>